import { connect } from 'react-redux';

import selectMergedPermissions from '../../components/permissions_manager/selectors';
import { segmentTrackEvent } from '../../ducks/analytics_tracking/thunks';
import { initialState } from '../../ducks/common_acls/slice';
import {
  addEntityAcls,
  getEntityAcls,
  getEntityCurrentAcls,
} from '../../ducks/common_acls/thunks';
import type { CommonAclsPrefix } from '../../ducks/common_acls/types';
import type { AppState } from '../../store/types';
import { defaultPermissions, type PermissionValues } from '../../types/common';
import type { SelectOption } from '../../ui/select_field/types';
import { selectUserRoles } from '../../utils/get_user_roles';

export type AclEntity = {
  id: string;
  aclsType: CommonAclsPrefix;
};

type SingleProps = {
  // Optional because panel kits pass the route entity id, which is absent on
  // routes without an :id; the panel already guards on a truthy objectId.
  objectId: string | undefined;
  aclsType: CommonAclsPrefix;
};

type BatchProps = {
  entities: AclEntity[];
};

type OwnProps = (SingleProps | BatchProps) & {
  defaultExpanded?: boolean;
  permissions?: PermissionValues;
  additionalTeamOptions?: SelectOption[];
};

const mapStateToProps = (state: AppState, ownProps: OwnProps) => {
  if ('aclsType' in ownProps) {
    return {
      acls: state.acls[ownProps.aclsType],
      roles: selectUserRoles(state),
      permissions:
        ownProps.permissions ??
        selectMergedPermissions(state, ownProps.aclsType, ownProps.objectId) ??
        defaultPermissions,
      ...ownProps,
    };
  }
  return {
    acls: initialState,
    roles: selectUserRoles(state),
    permissions: defaultPermissions,
    ...ownProps,
  };
};

const connector = connect(mapStateToProps, {
  addEntityAcls,
  getEntityAcls,
  getEntityCurrentAcls,
  segmentTrackEvent,
});

export default connector;
